module.exports = __webpack_public_path__ + "img/resource-processing.17511755.png";